import { SITE } from "@/data/site";
import SocialIconRow from "@/components/shared/SocialIconRow";
import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <span className={styles.copyright}>
        &copy; {new Date().getFullYear()} {SITE.name}. All rights reserved.
      </span>
      <div className={styles.socials}>
        <SocialIconRow />
        <span className={styles.legalDivider} />
        <a href="/privacy/" className={styles.socialLink}>
          Privacy
        </a>
        <a href="/terms-of-service/" className={styles.socialLink}>
          Terms
        </a>
      </div>
    </footer>
  );
}
